/* RESPONSIBLE TEAM: team-reporting */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { getOwner } from '@ember/application';
import type IntlService from 'ember-intl/services/intl';
import type AppService from 'embercom/services/app-service';
import type Store from '@ember-data/store';
import ManageSchedulesApi from 'embercom/lib/reporting/manage-schedules-api';

export default class ManageSchedulesRoute extends Route {
  @service intl!: IntlService;
  @service declare permissionsService: $TSFixMe;
  @service declare appService: AppService;
  @service declare store: Store;

  titleToken = this.intl.t('reporting.manage-schedules.title');

  async beforeModel(transition: any) {
    if (!this.appService.app.canUseFeature('reporting-sharing-scheduling')) {
      return this.transitionTo('apps.app.reports.overview');
    }
    return this.permissionsService.ensurePermissionWhenTransitioning('can_export_csv', transition);
  }

  async model() {
    await this.store.findAll('role');

    let api = new ManageSchedulesApi(getOwner(this));
    await api.loadPage();
    return api;
  }

  resetController(controller: any, isExiting: boolean) {
    if (isExiting) {
      controller.model?.reset();
    }
  }
}
